export const config: Config = {
    envName: process.env.REACT_APP_ENV || '',
    apiUrl: process.env.REACT_APP_API_URL || '',
    signalRUrl: process.env.REACT_APP_SIGNALR_URL || '',
    version: process.env.REACT_APP_VERSION || '1.3.4.100',
    okta: {
        issuer: process.env.REACT_APP_OKTA_ISSUER || '',
        clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '',
        redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || '',
    },
};

export type Config = {
    envName: string;
    apiUrl: string;
    signalRUrl: string;
    version: string;
    okta: {
        issuer: string;
        clientId: string;
        redirectUri: string;
    };
};
